<div class="d-flex align-items-center" style="height: 83vh;">
  <div>
    <div class="auth-title">
      <h3>{{ 'forgot_password' | translate }}</h3>
      <p>{{ 'login_text' | translate }}</p>
    </div>
    <app-alert></app-alert>
    <form class="auth-form-box" [formGroup]="form" (ngSubmit)="submit()">
      <div class="auth-box mb-3">
        <label for="email" class="form-label">{{ 'email' | translate }}</label>
        <input type="text" class="form-control" id="email"
          placeholder="{{ 'enter_email_address' | translate }}"
          formControlName="email">
        @if(email?.touched && email?.errors?.['required']){
        <div class="invalid-feedback">
          {{ 'email_is_required' | translate }}
        </div>
        }@else if(email?.touched && email?.errors?.['email']){
        <div class="invalid-feedback">
          {{ 'invalid_email' | translate }}
        </div>
        }
      </div>
      <app-button [class]="'btn'" [type]="'submit'" [id]="'forgot_password_btn'"
        [spinner]="true">{{'send' | translate}}</app-button>
      <a href="javascript:void(0)" class="modal-back" (click)="backForm()">
        <i class="ri-arrow-left-line"></i>
      </a>

    </form>
  </div>
</div>
